import _ from 'lodash';
import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';
import Validators from '../utils/Validators.js';

const CHANGE_EVENT = 'change';
const Constants = SelectCustomerConstants;
const ActionTypes = Constants.ActionTypes;
let _searchValue,
    _isLoading = false,
    _errorList = [],
    _canSearch = false,
    _searchResult = Constants.SearchResult.UNKNOWN;

function validateField(field) {
    let rules = field.validationRules;
    if (!rules) {
        Validators.clearErrorListForField(_errorList, field.id);
        return;
    }
    else {
        let data = {};
        data[field.model] = field.value;
        Validators.validateField(data, rules, field.customAttributeNames, _errorList, field.id, field.model);
    }
}

function resetSearch(canSearch) {
    _canSearch = canSearch;
    _searchResult = Constants.SearchResult.UNKNOWN;
}

function updateSearchValue(searchValue) {
    _searchValue = searchValue;
    const field = _.assign(Constants.ClientSearch, { value: searchValue });
    validateField(field);
    resetSearch(false);
}

function clearSearchValue() {
    _searchValue = undefined;
    _errorList = [];
    resetSearch(false);
}

function validateClientSearch() {
    const field = _.assign(Constants.ClientSearch, { value: _searchValue });
    validateField(field);
    const valid = _errorList && _errorList.length === 0;
    resetSearch(valid);
}

function setSearchResult(result) {
    _searchResult = result && result.clients && result.clients.length > 0 ?
        Constants.SearchResult.FOUND :
        Constants.SearchResult.NOT_FOUND;
}

class ClientSearchStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getSearchValue() {
        return _searchValue;
    }

    getErrorList() {
        return _errorList;
    }

    getCanSearch() {
        return _canSearch;
    }

    getSearchResult() {
        return _searchResult;
    }

    getIsLoading() {
        return _isLoading;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ClientSearchStore = new ClientSearchStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
ClientSearchStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.UPDATE_CLIENT_SEARCH:
            updateSearchValue(action.searchValue);
            break;

        case ActionTypes.VALIDATE_CLIENT_SEARCH:
            validateClientSearch();
            break;

        case ActionTypes.CLIENT_SEARCH_STARTED:
            _isLoading = true;
            _canSearch = false;
            break;

        case ActionTypes.CLEAR_CLIENT_SEARCH:
            clearSearchValue();
            break;

        case ActionTypes.CLIENT_SEARCH_COMPLETED:
            _isLoading = false;
            setSearchResult(action.result);
            break;

        default:
            return true;
    }

    ClientSearchStore.emitChange();
    return true;
});

export default ClientSearchStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ClientSearchStore.js